import "./header.css"
function Headers(){
    return(
        <header>
            <ul>
                <li><a href="/">Qui je suis ?</a></li>
                <li><a href="/projet">Projets</a></li>
                <li><a href="/Competence">Compétences</a></li>
                <li><a href="/reseaux">Réseaux sociaux</a></li>
            </ul>
        </header>
    )
}
export default Headers